import { Component, OnDestroy, OnInit } from '@angular/core';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { distinctUntilChanged, take, takeWhile } from 'rxjs/operators';
import { TranslateService } from 'src/app/shared/services/translate.service';
import {
  Carrito,
  EntradasService,
  StepperNavigationService,
  VentaService,
} from '../../../venta';
import moment from 'moment';
import { PagerService } from '../../../../shared/services/pager.service';
import { Entrada } from '../../../venta/models/entrada.model';
import { ModalService } from 'src/app/shared/services/modal.service';
import { VisorService } from 'src/app/shared/services/visor.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfigurationService } from 'src/app/core';
import { NumpadService } from 'src/app/shared/services/numpad.service';
import { FormControlService } from 'src/app/shared/services/form-control.service';
import { Router } from '@angular/router';
import { PermisosService } from 'src/app/core/security/permisos.service';
import { UserManagerService } from 'src/app/core/auth/user-manager.service';
import { AmigosThyssenService } from '../../services/amigos-thyssen.service';

interface Categoria {
  pkId: string;
  nombre: string;
  Descripcion: string;
  TipoProducto: string;
  expandido: boolean;
}

@Component({
  selector: 'amigos-thyssen-selector-mas-entradas',
  templateUrl: './selector-mas-entradas.component.html',
  styleUrls: ['./selector-mas-entradas.component.scss'],
})
export class AmigosThyssenSelectorMasEntradasComponent
  implements OnInit, OnDestroy
{
  categorias: Categoria[];
  config = PERFECT_SCROLLBAR_CONFIG;
  categoriaActiva: Categoria;
  subcategoriasSeleccionadas: Categoria[];
  entradas: Entrada[];
  ultimaSubcategoriaCargada: Categoria[] = [];
  cargandoCategorias = false; // Flag para evitar llamadas simultáneas múltiples

  tiposProducto: [{ Cod: string; Desc: string }] = [{ Cod: null, Desc: null }];
  gruposAsociados: [{ Cod: string; Desc: string }] = [
    { Cod: null, Desc: null },
  ];
  tiposNivel: [{ Cod: string; Desc: string }] = [{ Cod: null, Desc: null }];

  filtroTiposProducto: string;
  filtroGruposAsociados: string;
  filtroTiposNivel: string;

  entradaSeleccionada: Entrada;

  pager: any = {};
  pagedItems: any[];

  busquedaForm: FormGroup;
  filtrosForm: FormGroup;
  filtrosTextForm: FormGroup;
  carrito: Carrito;
  idioma = 'es-ES';

  myFormSub: Subscription;

  fecha: any;
  cliente: any;

  referrer: string;

  private alive = true;
  divisaSimboloDecimal: string;
  divisaSimbSeparacionMiles: string;
  divisaSimbolo: string;
  divisaDecimales: number;
  divisaPosicion: string;
  esGranDivisa: boolean;
  divisaSimboloDerecha: string;

  filtradoPorProducto = '';
  filtradoPorGrupoAso = '';
  filtradoPorNivel = '';
  filtradoPorNombre = '';
  verSelectores = false;

  private datosInicioSub: Subscription;
  private carritoSub: Subscription;
  private fechaSeleccionadaSub: Subscription;
  private clienteSeleccionadoSub: Subscription;
  private recalculaCarritoSub: Subscription;
  private subscriptions: Subscription[] = [];
  private amigoActivoAnterior?: { iCodigoClienteVinculado: string };

  constructor(
    private ventaService: VentaService,
    private configurationService: ConfigurationService,
    private entradaService: EntradasService,
    private numpadService: NumpadService,
    private formControlService: FormControlService,
    private modalService: ModalService,
    private pagerService: PagerService,
    private formBuilder: FormBuilder,
    private visor: VisorService,
    private router: Router,
    private permisosService: PermisosService,
    private user: UserManagerService,
    private navigationService: StepperNavigationService,
    private amigosThyssenService: AmigosThyssenService
  ) {
    this.busquedaForm = this.formBuilder.group({
      cliente: '',
      fecha: '',
    });
    this.filtrosForm = this.formBuilder.group({
      tipoproducto: '',
      rangoedad: '',
      tiponivel: '',
    });
    this.filtrosTextForm = this.formBuilder.group({
      busqueda: '',
    });
  }

  ngOnInit() {
    // Inicializar el amigo activo anterior para poder detectar cambios
    const amigoInicial = this.amigosThyssenService.getAmigoActivo();
    if (amigoInicial && amigoInicial.iCodigoClienteVinculado) {
      this.amigoActivoAnterior = { iCodigoClienteVinculado: amigoInicial.iCodigoClienteVinculado };
    }
    
    if (
      this.ventaService.carritoValue.entradas.length > 0 &&
      this.categorias === undefined &&
      this.entradas === undefined &&
      this.ventaService.irPago === true
    ) {
      this.navigationService.continuarVenta.next(true);
      this.navigationService.next();
      this.ventaService.irPago = false;
    }

    this.divisaSimbSeparacionMiles =
      this.configurationService.divisasValue[0].SimbSeparacionMiles;
    this.divisaSimboloDecimal =
      this.configurationService.divisasValue[0].SimboloDecimal;
    this.divisaSimbolo = this.configurationService.divisasValue[0].simbolo;
    this.divisaDecimales = Number(
      this.configurationService.divisasValue[0].NumeroDecimales
    );
    this.divisaPosicion =
      this.configurationService.divisasValue[0].PosicionDivisa;
    this.divisaSimboloDerecha =
      this.configurationService.divisasValue[0].SimboloDerecha;
    this.datosInicioSub = this.configurationService.datosInicio.subscribe(
      (conf) => (this.idioma = conf.Idioma)
    );
    this.carritoSub = this.ventaService.carrito.subscribe(
      (carrito) => (this.carrito = carrito)
    );
    this.fechaSeleccionadaSub = this.ventaService.fechaSeleccionada
      .pipe(takeWhile(() => this.alive))
      .subscribe((fecha) => {
        if (fecha === '') {
          this.ventaService.modificarTarifasFecha(
            moment().format('YYYY/MM/DD')
          );
          this.fecha = '';
          this.busquedaForm.get('fecha').setValue('');
        } else {
          this.ventaService.modificarTarifasFecha(
            moment(fecha).format('YYYY/MM/DD')
          );
          this.fecha = fecha;
          this.busquedaForm.controls['fecha'].patchValue(
            moment(this.fecha).locale(this.idioma).format('L')
          );
        }
        // Recargar categorías cuando cambia la fecha (la fecha puede afectar los resultados)
        // Limpiar categorías para forzar recarga con la nueva fecha
        if (!this.cargandoCategorias) {
          this.categorias = null; // Limpiar para forzar recarga
          this.onChanges();
        }
      });
    this.clienteSeleccionadoSub = this.ventaService.clienteSeleccionado
      .pipe(takeWhile(() => this.alive))
      .subscribe((cliente) => {
        const clienteAnterior = this.cliente;
        const clienteAnteriorCodigo = clienteAnterior?.Codigo;
        const clienteNuevoCodigo = cliente?.Codigo;
        
        this.cliente = cliente;
        this.busquedaForm.controls['cliente'].patchValue(
          cliente ? cliente.NombreCliente : ''
        );
        
        // Verificar si hay un amigo Thyssen activo y si el cliente cambió
        // Usar setTimeout para que se ejecute después de que se establezca el nuevo amigo activo
        setTimeout(() => {
          const amigoActivo = this.amigosThyssenService.getAmigoActivo();
          const amigoActivoCodigo = amigoActivo?.iCodigoClienteVinculado;
          
          // Si hay un amigo Thyssen activo y el código de cliente cambió, recargar datos
          if (amigoActivo && amigoActivoCodigo && 
              clienteNuevoCodigo && clienteNuevoCodigo !== clienteAnteriorCodigo &&
              amigoActivoCodigo !== this.amigoActivoAnterior?.iCodigoClienteVinculado) {
            // Guardar el nuevo amigo activo para la próxima comparación
            this.amigoActivoAnterior = { iCodigoClienteVinculado: amigoActivoCodigo };
            
            // Limpiar categorías y entradas para forzar recarga
            this.categorias = null;
            this.entradas = [];
            this.categoriaActiva = null;
            
            // Recargar filtros (GetTiposProductos y GetGruposAsociados)
            this.cargarFiltros();
            
            // Llamar a onChanges para recargar categorías con el nuevo amigo
            if (!this.cargandoCategorias) {
              this.onChanges();
            }
          } else if (amigoActivo && amigoActivoCodigo) {
            // Actualizar el amigo activo anterior aunque no haya cambiado el cliente
            this.amigoActivoAnterior = { iCodigoClienteVinculado: amigoActivoCodigo };
          }
        }, 100); // Pequeño delay para asegurar que el amigo activo se haya actualizado
      });
    this.subscriptions.push(this.datosInicioSub);
    this.subscriptions.push(this.fechaSeleccionadaSub);
    this.subscriptions.push(this.carritoSub);
    this.subscriptions.push(this.clienteSeleccionadoSub);

    // Cargar Lista de Filtros Posibles
    this.entradaService
      .getFiltroTiposProducto()
      .pipe(takeWhile(() => this.alive))
      .subscribe((filtro: any) => {
        if (
          filtro != null &&
          filtro.DatosResult != null &&
          filtro.DatosResult.ListadoTiposProductos != null
        ) {
          this.tiposProducto = filtro.DatosResult.ListadoTiposProductos.map(
            (x: any) => ({
              Cod: x.Codigo,
              Desc: x.Descripcion,
            })
          );
        } else {
          this.tiposProducto = [{ Cod: null, Desc: null }];
        }
      });
    this.entradaService
      .getFiltroGruposAsociado()
      .pipe(takeWhile(() => this.alive))
      .subscribe((filtro: any) => {
        if (
          filtro != null &&
          filtro.DatosResult != null &&
          filtro.DatosResult.ListadoGruposAsociados != null
        ) {
          this.gruposAsociados = filtro.DatosResult.ListadoGruposAsociados.map(
            (x: any) => ({
              Cod: x.Codigo,
              Desc: x.Descripcion,
            })
          );
        } else {
          this.gruposAsociados = [{ Cod: null, Desc: null }];
        }
      });
    this.entradaService
      .getFiltroTiposNiveles()
      .pipe(takeWhile(() => this.alive))
      .subscribe((filtro: any) => {
        if (
          filtro != null &&
          filtro.DatosResult != null &&
          filtro.DatosResult.ListadoTiposNiveles != null
        ) {
          this.tiposNivel = filtro.DatosResult.ListadoTiposNiveles.map(
            (x: any) => ({
              Cod: x.Codigo,
              Desc: x.Descripcion,
            })
          );
        } else {
          this.tiposNivel = [{ Cod: null, Desc: null }];
        }
      });
    this.visor.setToBlank();
  }

  ngOnDestroy() {
    this.alive = false;
    if (this.myFormSub) {
      this.myFormSub.unsubscribe();
    }
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Carga los filtros GetTiposProductos y GetGruposAsociados
   * Estos métodos deben llamarse después de cada validación de amigo Thyssen
   */
  private cargarFiltros(): void {
    // Cargar GetTiposProductos
    this.entradaService
      .getFiltroTiposProducto()
      .pipe(takeWhile(() => this.alive))
      .subscribe((filtro: any) => {
        if (
          filtro != null &&
          filtro.DatosResult != null &&
          filtro.DatosResult.ListadoTiposProductos != null
        ) {
          this.tiposProducto = filtro.DatosResult.ListadoTiposProductos.map(
            (x: any) => ({
              Cod: x.Codigo,
              Desc: x.Descripcion,
            })
          );
        } else {
          this.tiposProducto = [{ Cod: null, Desc: null }];
        }
      });
    // Cargar GetGruposAsociados
    this.entradaService
      .getFiltroGruposAsociado()
      .pipe(takeWhile(() => this.alive))
      .subscribe((filtro: any) => {
        if (
          filtro != null &&
          filtro.DatosResult != null &&
          filtro.DatosResult.ListadoGruposAsociados != null
        ) {
          this.gruposAsociados = filtro.DatosResult.ListadoGruposAsociados.map(
            (x: any) => ({
              Cod: x.Codigo,
              Desc: x.Descripcion,
            })
          );
        } else {
          this.gruposAsociados = [{ Cod: null, Desc: null }];
        }
      });
  }

  private obtenerPadreDePrimeraSubcategoria(categoria: any): any {
    let padre = null;
    while (categoria.categorias && categoria.categorias.length > 0) {
      padre = categoria;
      categoria = categoria.categorias[0];
    }
    return padre;
  }

  getPrecioConComision(entrada: Entrada): number {
    const precio = parseFloat((entrada.PrecioEnDivisaReferencia || '0').replace(',', '.'));
    const comision = parseFloat((entrada.Comision || '0').replace(',', '.'));
    console.log('🔍 [SELECTOR_MAS_ENTRADAS] Precio con comision:', {
      precio: precio,
      comision: comision,
      precioConComision: precio + comision
    });
    return (precio + comision);
  }

  onChanges() {
    // Protección: evitar llamadas múltiples simultáneas
    if (this.cargandoCategorias) {
      return;
    }
    
    // Verificar si el amigo activo cambió - si cambió, debemos recargar aunque haya categorías
    const amigoActivo = this.amigosThyssenService.getAmigoActivo();
    const amigoActivoCodigo = amigoActivo?.iCodigoClienteVinculado;
    const amigoCambio = this.amigoActivoAnterior?.iCodigoClienteVinculado !== amigoActivoCodigo;
    
    // Si ya tenemos categorías cargadas Y el amigo no cambió, no volver a cargar
    if (this.categorias && this.categorias.length > 0 && !amigoCambio) {
      return;
    }
    
    // Si el amigo cambió, actualizar la referencia
    if (amigoCambio && amigoActivoCodigo) {
      this.amigoActivoAnterior = { iCodigoClienteVinculado: amigoActivoCodigo };
    }
    
    // Aquí es donde cambia la lógica para amigos-thyssen
    // En lugar de usar el servicio de restauración, usamos el de amigos-thyssen
    const amigo = this.amigosThyssenService.getAmigoActivo();

    if (amigo && amigo.iCodigoClienteVinculado) {
      this.cargandoCategorias = true;
      
      // No enviar fecha según la especificación de la US
      // Para Amigos Thyssen, GetKoreCategorias y GetKoreTarifasDisponibles solo requieren:
      // CodigoCliente, FiltrarPorCliente: "1", TPVId: "0"
      
      // Cargar categorías específicas para el amigo validado
      this.amigosThyssenService
        .cargarCategoriasYTarifas(amigo.iCodigoClienteVinculado, undefined)
        .pipe(take(1))
        .subscribe(
          ({ categorias, tarifas }) => {
            if (categorias && categorias.length > 0) {
              // Transformar las categorías al formato esperado
              this.categorias = categorias.map((cat: any) => ({
                pkId: cat.pkId || cat.Id || cat.Codigo,
                nombre: cat.nombre || cat.Nombre || cat.Descripcion,
                Descripcion: cat.Descripcion || cat.nombre || cat.Nombre,
                TipoProducto: cat.TipoProducto || '1',
                expandido: false,
                categorias: cat.categorias || [],
              }));

              this.categoriaActiva = this.categorias[0];
              this.categoriaActiva.expandido = true;
              this.subcategoriasSeleccionadas = [];
              this.ultimaSubcategoriaCargada = [];

              // Cargar las entradas al iniciar
              this.cargarEntradas();
            } else {
              this.entradas = [];
            }
            this.cargandoCategorias = false;
          },
          (error) => {
            this.cargandoCategorias = false;
          }
        );
    } else {
      // Si no hay amigo activo, cargar categorías normales
      this.entradaService
        .getCategorias(this.fecha, this.cliente)
        .pipe(take(1))
        .subscribe((res: any) => {
          if (res && res.length > 0) {
            this.categorias = this.inicializarCategorias(res);
            this.categoriaActiva = this.categorias[0];
            this.categoriaActiva.expandido = true;
            this.subcategoriasSeleccionadas = [];
            this.ultimaSubcategoriaCargada = [];
            this.cargarEntradas();
          } else {
            this.entradas = [];
          }
        });
    }
  }

  private inicializarCategorias(categorias: any[]): Categoria[] {
    return categorias.map((cat: any) => ({
      pkId: cat.pkId || cat.Id || cat.Codigo,
      nombre: cat.nombre || cat.Nombre || cat.Descripcion,
      Descripcion: cat.Descripcion || cat.nombre || cat.Nombre,
      TipoProducto: cat.TipoProducto || '1',
      expandido: false,
      categorias: cat.categorias || [],
    }));
  }

  cargarEntradas() {
    if (!this.categoriaActiva) {
      return;
    }

    const amigo = this.amigosThyssenService.getAmigoActivo();


    if (amigo && amigo.iCodigoClienteVinculado) {
      // Obtener la fecha seleccionada (puede venir de this.fecha o de ventaService)
      const fechaParaEnviar = this.fecha || this.ventaService.fechaSeleccionadaValue;
      
      // Cargar entradas específicas para el amigo y la categoría seleccionada
      this.amigosThyssenService
        .cargarTarifasPorCategoria(
          amigo.iCodigoClienteVinculado,
          this.categoriaActiva.pkId,
          fechaParaEnviar
        )
        .pipe(take(1))
        .subscribe(
          (tarifas) => {
            if (tarifas && tarifas.length > 0) {
              // Transformar las tarifas al formato de Entrada
              this.entradas = tarifas.map((tarifa: any) => ({
                ...tarifa,
                idTarifa: tarifa.idTarifa || tarifa.Id || tarifa.Codigo,
                NombrePantalla:
                  tarifa.NombrePantalla || tarifa.Nombre || tarifa.Descripcion,
                PrecioEnDivisaReferencia:
                  tarifa.PrecioEnDivisaReferencia || tarifa.PrecioBase || 0,
                TipoEntradaId:
                  tarifa.TipoEntradaId || tarifa.Id || tarifa.Codigo,
                TipoProducto: tarifa.TipoProducto || '1',
                noEditable: false,
              }));

              /* Cargar Recintos Entrada */
              let entradasIdsArr = [];
              if (this.entradas && this.entradas.length > 0) {
                this.entradas.forEach((entrada) => {
                  if (entrada.TipoProducto === '2' && entrada.PromocionEntradas) {
                    entrada.PromocionEntradas.forEach((item) => {
                      entradasIdsArr.push(item.TipoEntradaId);
                    });
                  } else if (entrada.TipoProducto === '1') {
                    entradasIdsArr.push(entrada.TipoEntradaId);
                  }
                });
                const set = new Set(entradasIdsArr);
                entradasIdsArr = [...set];
                const entradasIds = entradasIdsArr.join();
                this.entradaService
                  .getRecintosEntrada(entradasIds)
                  .subscribe((res: any) => {
                    if (res.DatosResult === null) {
                      return;
                    }
                    const recintos = res.DatosResult.RecintosDisponibles;
                    this.entradas.forEach((e) => {
                      const recintosArr = [];
                      if (e.TipoProducto === '1') {
                        recintos.filter((recinto) => {
                          if (recinto.TipoEntrada === e.TipoEntradaId) {
                            recintosArr.push(recinto);
                          }
                        });
                      } else if (e.TipoProducto === '2') {
                        e.PromocionEntradas.forEach((item) => {
                          e.recintos = recintos.filter((recinto) => {
                            if (recinto.TipoEntrada === item.TipoEntradaId) {
                              recintosArr.push(recinto);
                            }
                          });
                        });
                      }
                      e.recintos = [...recintosArr];
                    });
                  });
                //
                if (this.entradas && this.entradas.length > 0) {
                  if (
                    this.filtrosTextForm.value.busqueda &&
                    this.filtrosTextForm.value.busqueda.length > 2
                  ) {
                    this.filtradoPorNombre =
                      this.filtrosTextForm.value.busqueda;
                    //
                    this.entradas = this.entradas.filter(
                      (item) =>
                        (item.NombreTipo &&
                          item.NombreTipo.toLowerCase().includes(
                            this.filtrosTextForm.value.busqueda.toLowerCase()
                          )) ||
                        (item.NombrePantalla &&
                          item.NombrePantalla.toLowerCase().includes(
                            this.filtrosTextForm.value.busqueda.toLowerCase()
                          )) ||
                        (item.NombreDisplay &&
                          item.NombreDisplay.toLowerCase().includes(
                            this.filtrosTextForm.value.busqueda.toLowerCase()
                          ))
                    );
                  }
                }

                //
                this.setPage(1);
              }

              /* End recintos entrada */
            } else {
              this.entradas = [];
            }
            this.setPage(1);
          },
          (error) => {
          }
        );
    } else {
      // Cargar entradas normales
      this.entradaService
        .getEntradas(this.categoriaActiva.pkId, this.fecha, this.cliente)
        .pipe(take(1))
        .subscribe(
          (entradas: Entrada[]) => {
            this.entradas = entradas;
            this.setPage(1);
          },
          (error) => {
          }
        );
    }
  }

  seleccionCategoria(id: string, borrar: boolean = true): void {
    this.categoriaActiva = this.categorias.find((cat) => cat.pkId === id);


    // Limpiamos los filtros
    this.filtroTiposProducto = '';
    this.filtroGruposAsociados = '';
    this.filtroTiposNivel = '';
    this.filtradoPorGrupoAso = '';
    this.filtradoPorProducto = '';
    this.filtradoPorNivel = '';
    if (borrar) this.filtradoPorNombre = '';
    this.filtrosForm.controls['tipoproducto'].setValue('');
    this.filtrosForm.controls['rangoedad'].setValue('');
    this.filtrosForm.controls['tiponivel'].setValue('');
    if (borrar) this.filtrosTextForm.controls['busqueda'].setValue('');

    if (this.categoriaActiva && this.categoriaActiva.Descripcion == 'EXTERNO') {
      this.verSelectores = true;
    } else {
      this.verSelectores = false;
    }

    // Cargar entradas para la categoría seleccionada
    this.cargarEntradas();
  }

  eliminarEntrada(entrada: any): void {
    if (
      entrada.noEditable ||
      this.ventaService.carritoValue.reservaAgrupada == '1'
    ) {
      return;
    }

    // Para amigos-thyssen, eliminar con el DNI del amigo activo
    const amigo = this.amigosThyssenService.getAmigoActivo();
    if (amigo) {
      const entradaConDni = { ...entrada, DNIAbonadosExt: amigo.namigo };
      this.ventaService.removeEntrada(entradaConDni);
    } else {
      this.ventaService.removeEntrada(entrada);
    }
  }

  agregarEntrada(entrada: Entrada): void {
    if (
      entrada.noEditable ||
      this.ventaService.carritoValue.reservaAgrupada == '1' ||
      (this.verSelectores &&
        (this.filtroTiposProducto == '' ||
          this.filtroGruposAsociados == '' ||
          this.filtroTiposNivel == ''))
    ) {
      return;
    }

    // Para amigos-thyssen, añadir con el DNI del amigo
    const amigo = this.amigosThyssenService.getAmigoActivo();
    if (amigo) {
      const entradaConDni = { ...entrada, DNIAbonadosExt: amigo.namigo };
      this.ventaService.sendEntrada(entradaConDni);
    } else {
      this.ventaService.sendEntrada(entrada);
    }
  }

  getCantidadPorEntrada(entrada: Entrada): number {
    // Para amigos-thyssen, buscar con el DNI del amigo activo
    const amigo = this.amigosThyssenService.getAmigoActivo();
    if (amigo) {
      const entradaConDni = { ...entrada, DNIAbonadosExt: amigo.namigo };
      return this.ventaService.getCantidadPorEntrada(entradaConDni);
    } else {
      return this.ventaService.getCantidadPorEntrada(entrada);
    }
  }

  setPage(page: number): void {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.pager = this.pagerService.getPager(this.entradas.length, page);
    this.pagedItems = this.entradas.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  seleccionarEntrada(entrada: Entrada): void {
    this.entradaSeleccionada = entrada;
  }

  mostrarSubcategorias(
    categoria: Categoria,
    expandir = true,
    esSubcategoria = false
  ): void {
    if (expandir) {
      categoria.expandido = !categoria.expandido;
      this.categoriaActiva = categoria;
    }

    if (esSubcategoria) {
      this.subcategoriasSeleccionadas = [categoria];
    } else {
      this.subcategoriasSeleccionadas = [];
    }

    this.cargarEntradas();
  }

  cambiodeFiltro(event: any, tipo: string): void {
    const valor = event.value;

    switch (tipo) {
      case 'TP':
        this.filtradoPorProducto = valor;
        this.filtroTiposProducto = valor;
        break;
      case 'RE':
        this.filtradoPorGrupoAso = valor;
        this.filtroGruposAsociados = valor;
        break;
      case 'TN':
        this.filtradoPorNivel = valor;
        this.filtroTiposNivel = valor;
        break;
    }

    this.aplicarFiltros();
  }

  cambiodeFiltroTexto(): void {
    const valor = this.filtrosTextForm.get('busqueda')?.value || '';
    this.filtradoPorNombre = valor;
    this.aplicarFiltros();
  }

  eliminarFiltro(event: any, tipo: string): void {
    switch (tipo) {
      case 'TP':
        this.filtradoPorProducto = '';
        this.filtroTiposProducto = '';
        this.filtrosForm.patchValue({ tipoproducto: '' });
        break;
      case 'RE':
        this.filtradoPorGrupoAso = '';
        this.filtroGruposAsociados = '';
        this.filtrosForm.patchValue({ rangoedad: '' });
        break;
      case 'TN':
        this.filtradoPorNivel = '';
        this.filtroTiposNivel = '';
        this.filtrosForm.patchValue({ tiponivel: '' });
        break;
      case 'N':
        this.filtradoPorNombre = '';
        this.filtrosTextForm.patchValue({ busqueda: '' });
        break;
    }

    this.aplicarFiltros();
  }

  private aplicarFiltros(): void {
    // Aplicar filtros según la lógica de amigos-thyssen
    if (this.categoriaActiva) {
      this.cargarEntradas();
    }
  }

  tienePermiso(permiso: string): boolean {
    // Implementar lógica de permisos según sea necesario
    return true;
  }

  deberiaDestacarse(categoriaId: string): boolean {
    return false;
  }

  focusValue(event: any, entrada: Entrada): void {
    // Implementar lógica de focus si es necesario
  }

  unfocusValue(event: any): void {
    // Implementar lógica de unfocus si es necesario
  }

  inputDeTeclado(event: any, entrada: Entrada): void {
    // Implementar lógica de input de teclado si es necesario
  }

  filroCategoriaPrevio(): void {
    // Implementar navegación a categoría previa
  }

  filroCategoriaSiguiente(): void {
    // Implementar navegación a categoría siguiente
  }
}
